export default __webpack_public_path__ + "static/icon_menu_interview-1.0.0.png";